export const HOW_IT_WORKS = [
  {
    id: 1,
    title: 'Подберём агента за вас — и для вас',
    description:
      'Материнский капитал, дарение или незакрытая ипотека — найдём специалиста, у которого есть опыт работы с похожими объектами',
    imageClass: 'step-1',
  },
  {
    id: 2,
    title: 'Подготовим объект к успешной продаже',
    description:
      'Агент оценит недвижимость, чтобы не продешевить, напишет текст объявления и сфотографирует так, что её захочется купить',
    imageClass: 'step-2',
  },
  {
    id: 3,
    title: 'Ваше объявление увидят все',
    description:
      'Бесплатно подключим продвижение и отправим рекомендации потенциальным покупателям, чтобы объект продался быстрее',
    imageClass: 'step-3',
  },
  {
    id: 4,
    title: 'Звонки и просмотры — тоже на нас',
    description:
      'Агент возьмёт на себя общение с покупателями, презентацию объекта и добьётся лучшей цены — чтобы вы приложили минимум усилий и получили максимум прибыли',
    imageClass: 'step-4',
  },
  {
    id: 5,
    title: 'Вы в надёжных руках',
    description:
      'Мошенники не пройдут: агент поможет оформить документы без ошибок и убедится в безопасности расчётов, а Циан будет за всем присматривать',
    imageClass: 'step-5',
  },
  {
    id: 6,
    title: 'Поможем купить жильё взамен',
    description:
      'Агент найдёт подходящие варианты, проведёт все переговоры, подберёт удобные даты, чтобы сразу переехать, и поможет с оформлением сделки',
    imageClass: 'step-6',
  },
];
